import { IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { Chat, useGetChatQuery } from '../../api/graphql/generated';
import { Conversation } from '../../components/conversation/conversation';
import { ConversationModalProvider } from '../../components/conversation/conversation-modal-provider';
import { BackButtonProvider } from '../../components/header/back-button';
import { NestedPageHeader } from '../../components/header/page.header';
import { ChatNotificationToggleButton } from './chat-notification-toggle-button';

interface RouteParams {
  threadId: string;
}

interface ChatDetailsPageProps {
  chatId: string;
  defaultBackRoute: string;
}

const ChatThreadPage = (props: ChatDetailsPageProps): ReactElement => {
  const { chatId, defaultBackRoute } = props;

  const { data: chatData } = useGetChatQuery({
    variables: {
      input: {
        id: chatId,
      },
    },
  });

  const chat: Chat | undefined = chatData?.getChat;

  const params = useParams<RouteParams>();
  const { threadId } = params;

  return (
    <BackButtonProvider>
      <ConversationModalProvider id={chatId}>
        {({ containerRef }) => (
          <IonPage ref={containerRef}>
            <NestedPageHeader
              title={chat?.name}
              defaultBackRoute={defaultBackRoute}
              rightButtons={<ChatNotificationToggleButton chatId={chatId} />}
            />
            <Conversation chatId={chatId} threadId={threadId} />
          </IonPage>
        )}
      </ConversationModalProvider>
    </BackButtonProvider>
  );
};

export { ChatThreadPage };
